import { isMotionValue, transformPropOrder } from "motion-dom";
import { scrapeMotionValuesFromProps as scrapeHTMLMotionValuesFromProps } from "../../html/utils/scrape-motion-values";
export function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    const newValues = scrapeHTMLMotionValuesFromProps(props, prevProps, visualElement);
    for (const key in props) {
        if (isMotionValue(props[key]) ||
            isMotionValue(prevProps[key])) {
            const targetKey = transformPropOrder.indexOf(key) !== -1
                ? "attr" + key.charAt(0).toUpperCase() + key.substring(1)
                : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}
//# sourceMappingURL=scrape-motion-values.js.map